import { render, staticRenderFns } from "./MModalWrapper.vue?vue&type=template&id=95656ed2"
import script from "./MModalWrapper.vue?vue&type=script&lang=js"
export * from "./MModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./MModalWrapper.vue?vue&type=style&index=0&id=95656ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports